"use strict";
angular.module("internal.exams").controller("InternalExamView", [
    "$scope",
    "$stateParams",
    "Queries",
    "$state",
    "$window",
    function ($scope, $stateParams, Queries, $state, $window) {
        $scope.loading = true;
        $scope.queryId = $stateParams.queryId;
        $scope.query = { available: true };
        $scope.columns = [];
        $scope.columnsSelected = [];
        $scope.filters = [];
        $scope.filtersSelected = [];
        $scope.advancedFilters = [];
        $scope.advancedFiltersSelected = [];
        $scope.saveMessage = $stateParams.saveMessage;
        $scope.saving = false;
        $window.scrollTo(0, 0);
        if ($stateParams.queryId != null) {
            Queries.getByID($stateParams.queryId).then(function (query) {
                $scope.query = query;
                for (var x in $scope.query.query_column_values) {
                    $scope.columnsSelected.push($scope.query.query_column_values[x].query_column);
                    //for the 'default sort'select
                    $scope.defaultSortOptions.push({
                        name: $scope.query.query_column_values[x].query_column.name,
                        id: $scope.query.query_column_values[x].query_column.json
                    })
                }
                for (var x in $scope.query.query_filter_values) {
                    $scope.filtersSelected.push($scope.query.query_filter_values[x].query_filter);
                }
                for (var x in $scope.query.query_advanced_filter_values) {
                    $scope.advancedFiltersSelected.push($scope.query.query_advanced_filter_values[x].query_advanced_filters);
                }
                $scope.query.query_column_values = $scope.columnsSelected;
                $scope.query.query_filter_values = $scope.filtersSelected;
                $scope.query.query_advanced_filter_values = $scope.advancedFiltersSelected;
            });
        }
        Queries.getColumns('581C08D3-089F-4AAF-A95A-662C48A56983').then(function (columns) {
            $scope.columns = columns;
        });
        Queries.getFilters('581C08D3-089F-4AAF-A95A-662C48A56983').then(function (filters) {
            $scope.filters = filters;
        });
        Queries.getAdvancedFilters('581C08D3-089F-4AAF-A95A-662C48A56983').then(function (advancedFilters) {
            $scope.advancedFilters = advancedFilters;
        });
        Queries.getFields('581C08D3-089F-4AAF-A95A-662C48A56983').then(function (fields) {
            $scope.fields = fields;
        });
        $scope.loading = false;
        $scope.slushChange = function (values, type) {
            if (type == 'Columns') {
                $scope.query.query_column_values = values;
            } else if (type == 'Filters') {
                $scope.query.query_filter_values = values;
            } else if (type == 'Advanced Filter') {
                $scope.query.query_advanced_filter_values = values;
            }
        }
        $scope.defaultSortOptions = [];
        $scope.defaultRecordsOptions = [{
            id: '10',
            name: '10'
        }, {
            id: '15',
            name: '15'
        }, {
            id: '20',
            name: '20'
        }, {
            id: '25',
            name: '25'
        }, {
            id: '50',
            name: '50'
        }, {
            id: '100',
            name: '100'
        }, {
            id: '250',
            name: '250'
        }];
        $scope.defaultOrderOptions = [{
            id: 'asc',
            name: 'asc'
        }, {
            id: 'desc',
            name: 'desc'
        }];
        $scope.save = function () {
            $scope.saving = true;
            $scope.query.query_page_id = '581C08D3-089F-4AAF-A95A-662C48A56983'
            //Accomodate strange naming of header in [Query_Filter_Values] and[Query_Advanced_Filter_Values]
            for (var x in $scope.query.query_filter_values) {
                $scope.query.query_filter_values[x].display_label = $scope.query.query_filter_values[x].name;
            }
            for (var x in $scope.query.query_advanced_filter_values) {
                $scope.query.query_advanced_filter_values[x].label = $scope.query.query_advanced_filter_values[x].name;
            }
            Queries.save($scope.query, $scope.query.default_view).then(function (query) {
                if (query != null) {
                    $state.go("internal.exams.administrative.internalview.details", { queryId: query.id, query: query, saveMessage: "Record updated successfully" }, { reload: "internal.exams.administrative.internalview" });
                } else {
                    $scope.saveMessage = "Error: Save failed";
                    $window.scrollTo(0, 0);
                    $scope.saving = false;
                }
            });
        };
        $scope.delete = function () {
            $scope.deleting = true;
            if (window.confirm("Are you sure you want to delete this exam view?")) {
                Queries.delete($scope.query.id).then(function () {
                    $scope.deleting = false;
                    $state.go("internal.exams.administrative.internalviews", {}, { reload: "internal.exams.administrative.internalviews" });
                });
            } else {
                $scope.deleting = false;
            }
        };
    }]);